import React from "react";
import { team } from "../mock";

const Team = () => {
  return (
    <section id="team" className="section-pad bg-[#0e0e0f]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-serif-display text-white" style={{ fontSize: "clamp(2rem, 4vw, 3.5rem)" }}>
            Echipa Puternică din Spatele STG
          </h2>
          <p className="mt-4 text-neutral-400 text-[17px]">
            Arhitecți, designeri și vizionari uniți de o misiune comună.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {team.map((m) => (
            <div
              key={m.name}
              className="bg-[#17171a] rounded-2xl p-6 md:p-8 hover-lift text-center"
            >
              <div className="gold-frame w-56 h-56 mx-auto">
                <img
                  src={m.image}
                  alt={m.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <h3 className="mt-6 text-white font-semibold text-xl">{m.name}</h3>
              <div className="mt-2 text-[#f5b301] text-[13px] font-medium">{m.role}</div>
              <p className="mt-4 text-neutral-400 text-[14px] leading-relaxed">{m.bio}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
